export default __webpack_public_path__ + "static/volunteer-f4358db43275e5988089dd9b64e99eb9.jpg";